import { css } from 'aphrodite';
import * as React from 'react';
import { ILeaderboardDemos, IVerticalLeaderboard } from '../../viewModels/gamification';
import { DemosList, IDemosListRowItem } from './components/DemosList';
import { styleSheet } from './styles';

export interface ILeaderBoardProps {
	groupLabel?: string;
	renderEmptyState?: string | JSX.Element;
	renderFilter: JSX.Element;
	scores: ILeaderboardDemos | undefined;
}

const dialsFormat = new Intl.NumberFormat('en-US');

function toRows(board: IVerticalLeaderboard | undefined): IDemosListRowItem[] {
	const stats = board?.verticalStatistics ?? {};
	return Object.keys(stats).map(name => ({
		demos: stats[name]?.demos ?? 0,
		goal: Math.round(stats[name]?.goal || 0),
		label: name,
		name,
	}));
}

function toTotal(board: IVerticalLeaderboard | undefined): IDemosListRowItem | undefined {
	const total = board?.totalStatistics;
	return total ? { demos: total.demos ?? 0, goal: Math.round(total.goal || 0) } : undefined;
}

export const DemosScore: React.FC<ILeaderBoardProps> = ({
	groupLabel = 'Verticals',
	renderEmptyState,
	renderFilter,
	scores,
}) => {
	const roles = scores?.roleLeaderboards ?? {};

	return (
		<div className={css(styleSheet.dayBoard)}>
			{renderFilter}
			{scores ? (
				<span className={css(styleSheet.totalDials)}>{dialsFormat.format(scores.totalDials || 0)} Dials</span>
			) : null}
			{renderEmptyState || !scores ? (
				renderEmptyState
			) : (
				<div className={css(styleSheet.demosTables)}>
					<DemosList
						label={groupLabel}
						rows={toRows(scores.totalVerticalLeaderboard)}
						total={toTotal(scores.totalVerticalLeaderboard)}
					/>
					{Object.keys(roles).map(name => (
						<DemosList key={name} label={name} rows={toRows(roles[name])} total={toTotal(roles[name])} />
					))}
				</div>
			)}
		</div>
	);
};
